import React, {useCallback, useState} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Box, Container, Tab, Tabs} from '@mui/material';
import PageTitle from '../shared/PageTitle';
import Drills from './Drills';
import {useParams} from 'react-router-dom';
import CreateDrillDialog from './CreateDrillDialog';

interface Props {}

const Library: React.FC<Props> = () => {
  const {t} = useTranslation();
  const {teamId} = useParams();
  const [tabIndex, setTabIndex] = useState(0);

  const title = t('navigation.pageTitle', {pageName: t('pages.library')});

  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      setTabIndex(newValue);
    },
    [],
  );

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container>
        <PageTitle>{t('pages.library')}</PageTitle>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mb: 2,
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label={t('pages.drills')} />
          </Tabs>
          <CreateDrillDialog teamId={Number(teamId)} />
        </Box>
        <Box hidden={tabIndex !== 0}>
          <Drills />
        </Box>
      </Container>
    </>
  );
};

export default Library;
